(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vn-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vn-cart-indicator')) {
  customElements.define('vn-cart-indicator', class extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        this.hidden = Number(this.textContent.trim()) === 0;
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vn-scenes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vn-scene-carousel')) {
  customElements.define('vn-scene-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vn-scenes');
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.onClick = (event) => {
        const button = event.target.closest('[data-slide]');
        if (!button || !this.contains(button)) return;
        const slide = this.slides[Number(button.dataset.slide)];
        this.track.scrollTo({left: slide.offsetLeft - this.slides[0].offsetLeft});
      };
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const origin = this.slides[0]?.offsetLeft || 0;
          let selected = 0;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const delta = Math.abs(slide.offsetLeft - origin - this.track.scrollLeft);
            if (delta < distance) { selected = index; distance = delta; }
          });
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === selected)));
        });
      };
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.track.removeEventListener('scroll', this.update);
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
